import React from 'react';
import { capitalize } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { OffsetEliminationGroup } from '../../../../core/api/consolidation';
import { OffsetEliminatedGroup } from './offset-eliminated-group/offset-eliminated-group';
import { useConsolidationContext } from '../../../consolidation-context/consolidation-context';
import styles from './offset-eliminated-groups-list.scss';

export interface OffsetEliminatedGroupsListProps {
  dragItemId?: string;
  isDragging?: boolean;
  onDragEnd?: (event: React.DragEvent) => void;
  onDragStart?: (event: React.DragEvent, id: string) => void;
  onDrop?: (event: React.DragEvent, group: OffsetEliminationGroup) => void;
}

export const OffsetEliminatedGroupsList = ({
  dragItemId = '',
  isDragging,
  onDragEnd,
  onDragStart,
  onDrop
}: OffsetEliminatedGroupsListProps) => {
  const {
    eliminations: { eliminationGroups }
  } = useConsolidationContext();

  return (
    <div className={styles.container} data-testid={`OffsetEliminatedGoupsList`}>
      {Object.keys(eliminationGroups).length === 0 ? (
        <div className={styles.noData}>
          <FormattedMessage
            id="consolidation.please_add_your_first_elimination_group"
            defaultMessage="Please add your first elimination group."
          />
        </div>
      ) : (
        Object.keys(eliminationGroups).map(categoryName => {
          const categoryEliminations = eliminationGroups[categoryName];
          const categoryLabel = capitalize(categoryName.replace(/_/g, ' '));

          return categoryEliminations.map(elimination => (
            <div key={`${capitalize(categoryName)}-${capitalize(elimination.name)}`} className={styles.eliminationGroup}>
              <OffsetEliminatedGroup
                allowDrop={!elimination.accounts.includes(dragItemId)}
                categoryLabel={categoryLabel}
                elimination={elimination}
                isDragging={isDragging}
                onDragEnd={onDragEnd}
                onDragStart={onDragStart}
                onDrop={onDrop}
              />
            </div>
          ));
        })
      )}
    </div>
  );
};
